module.exports = __webpack_public_path__ + "static/media/defaultFont.96f2a21a.png";